export interface StatusParams {
  [index: string]: {
    count: number;
    annotated: number;
    validated: number;
    deleted: number;
  };
}

export interface StatusState {
  statuses: StatusParams;
  loading: boolean;
  error: null | string;
}

export interface StatusInfo {
  statuses: StatusParams;
  loading: boolean;
  error: null | string;
}

export enum StatusActionTypes {
  GET_STATUSES = "GET_STATUSES",
  GET_STATUSES_SUCCESS = "GET_STATUSES_SUCCESS",
  GET_STATUSES_ERROR = "GET_STATUSES_ERROR",
}

interface GetStatusesAction {
  type: StatusActionTypes.GET_STATUSES;
}

interface GetStatusesSuccessAction {
  type: StatusActionTypes.GET_STATUSES_SUCCESS;
  payload: StatusParams;
}

interface GetStatusesErrorAction {
  type: StatusActionTypes.GET_STATUSES_ERROR;
  payload: string;
}

export type statusesAction =
  | GetStatusesAction
  | GetStatusesSuccessAction
  | GetStatusesErrorAction;
